import { api } from "@libs/api/client";

export const getSecurityItems = async ({
  productName,
}: {
  productName?: string;
}) => {
  const { data } = await api["security-items"].get({ query: { productName } });

  return data;
};
